export default __webpack_public_path__ + "static/media/HillsToHome.defdd256.webp";